import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-loading">
        <span className="h-12 w-12 rounded-2xl bg-primary flex items-center justify-center animate-pulse"><Sparkles className="h-6 w-6 text-primary-foreground" /></span>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace state={{ next: location.pathname, ...location.state }} />;
  return children;
};

export default ProtectedRoute;
